import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import userReducer from './slices/userSlice';
import challengeReducer from './slices/challengeSlice';
import challengeAnswerSlice from './slices/challengeAnswerSlice';
import tipsSlice from './slices/tipsSlice';
import tipsIndexesSlice from './slices/tipsIndexesSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    user: userReducer,
    challenge: challengeReducer,
    challengeAnswer: challengeAnswerSlice,
    tips: tipsSlice,
    tipsIndexes: tipsIndexesSlice,
  }
});

